import { PRODUCT_LINKS } from '../config/links';

export type ProductId = 'acebook' | 'aiguide';
export type ProductStatus = 'online' | 'preparing';

export interface Product {
  readonly id: ProductId;
  readonly name: string;
  readonly role: string;
  readonly tagline: string;
  readonly audience: string;
  readonly problem: string;
  readonly field: string;
  readonly domain: string;
  readonly href: string;
  readonly status: ProductStatus;
  readonly screenshot: string;
  readonly screenshotAlt: string;
  readonly accent: 'orange' | 'cyan';
  readonly priority: 'primary' | 'secondary';
  readonly ctaLabel: string;
  readonly indexLabel: string;
  readonly highlights: readonly string[];
}

export const PRODUCTS = [
  {
    id: 'aiguide',
    name: 'AIGuide',
    role: 'AI learning path',
    tagline: '面向青少年的 AI 项目式学习入口。',
    audience: '青少年、家长与 AI 竞赛学习者',
    problem: '把零散的 AI 工具体验，组织成能持续学习、完成作品的项目路径。',
    field: 'AI 学习',
    domain: 'ai.acebook.online',
    href: PRODUCT_LINKS.aiguide,
    status: 'online',
    screenshot: '/product-screenshots/aiguide-home.png',
    screenshotAlt: 'AIGuide 公开首页脱敏截图',
    accent: 'cyan',
    priority: 'primary',
    ctaLabel: '开始 AI 学习',
    indexLabel: '01 / Flagship',
    highlights: ['项目式学习路径', '真实 AI 工具任务', '面向作品与竞赛准备'],
  },
  {
    id: 'acebook',
    name: 'ACEbook',
    role: 'Interactive content platform',
    tagline: '面向真实使用场景的在线电子书与内容交互产品。',
    audience: '课程内容、电子书与长期材料读者',
    problem: '为课程、案例和学习材料提供稳定、清晰的在线阅读与交互入口。',
    field: '教育内容',
    domain: 'banposter.acebook.online',
    href: PRODUCT_LINKS.acebook,
    status: 'online',
    screenshot: '/product-screenshots/acebook-login.png',
    screenshotAlt: 'ACEbook 公开登录页脱敏截图',
    accent: 'orange',
    priority: 'secondary',
    ctaLabel: '进入内容平台',
    indexLabel: '02 / Platform',
    highlights: ['在线阅读体验', '结构化内容组织', '持续更新的交互入口'],
  },
] as const satisfies readonly Product[];

export const PRODUCT_IDS = PRODUCTS.map((product) => product.id);
